module.exports = __webpack_public_path__ + "img/KK.3b085ba8.png";